import { unleashClient } from '../config'
import type { FeatureFlagKey } from './types'

export const getIsFeatureEnabled = (flagKey: FeatureFlagKey): boolean => {
  return unleashClient.isEnabled(flagKey)
}
